import { render, staticRenderFns } from "./ChatManage.vue?vue&type=template&id=5266f0af"
import script from "./ChatManage.vue?vue&type=script&lang=js"
export * from "./ChatManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports